/** @format */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonDirectiveModule, DcsgNgxEcommerceCommonModule } from '@dcsg-ngx-ecommerce/common';

import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MediaModule } from '@dcsg-ngx-ecommerce/engage/component/media/media.module';
import { TabbingComponent } from './tabbing.component';
import { WysiwygModule } from '../wysiwyg';

@NgModule({
	imports: [
		CommonDirectiveModule,
		CommonModule,
		DcsgNgxEcommerceCommonModule,
		MatExpansionModule,
		MatTabsModule,
		MediaModule,
		WysiwygModule
	],
	declarations: [TabbingComponent],
	exports: [TabbingComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TabbingModule {}
